module.exports = __webpack_public_path__ + "static/img/knives42.0a1dcf8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/knives42.jpg
// module id = pPnG
// module chunks = 0